import styled from "styled-components";
import { css } from "styled-components";
import myFontURL from "../../../../../assets/fonts/Poppins-Regular.ttf";

export const fontFaces = css`
  @font-face {
    font-family: "Poppins";
    src: url(${myFontURL}) format("ttf");
  }
`;

export const MainHeading = styled.div`
  font-family: Poppins;
  font-weight: 500;
  font-size: 22px;
  line-height: 20px;
  color: #030229;
`;

export const HelpIcon = styled.img`
  margin-left: 1rem;
  cursor: pointer;
`;

export const Input = styled.input`
  width: 30%;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  outline: none;
`;

export const HealthCard = styled.div`
  font-family: Poppins;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  margin-top: 2rem;
  color: #030229;
  background: white;
  border-radius: 10px;
  border: 2px solid #f5f6f7;
  padding: 1rem;
`;
export const HealthCardHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 5px;
  align-item: center;
`;

export const Title = styled.div`
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  color: #4d5e80;
`;
export const Button = styled.label`
  font-size: 15px;
  font-weight: 600;
  font-family: Poppins;
  border: none;
  border-radius: 4.36px;
  background-color: #2a3da3;
  color: white;
  cursor: pointer;
  // padding-inline: 7px;
  padding: 5px 9px;
  height: 28px;
  width: 28px;
`;

export const FileHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 15px 0px;
  border-top: 2px solid #f5f6f7;
`;

export const FileTitle = styled.div`
  font-family: Poppins;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  color: #4d5e80;
`;
